export const envs = {
	appType: import.meta.env.VITE_APP_TYPE,
	clientId: import.meta.env.VITE_API_CLIENTID,
	redirectUrl: import.meta.env.VITE_API_REDIRECT_URL,
	apiState: import.meta.env.VITE_API_STATE,
	umsBaseUrl: import.meta.env.VITE_UMS_API_URL,
	omsBaseUrl: import.meta.env.VITE_OMS_API_URL,
	d2rBaseUrl: import.meta.env.VITE_D2R_API_URL,
	cmsBaseUrl: import.meta.env.VITE_CMS_API_URL,
	wmsBaseUrl: import.meta.env.VITE_WMS_API_URL,
	hmsBaseUrl: import.meta.env.VITE_HMS_API_URL,
	openBaseUrl: import.meta.env.VITE_OPEN_API_URL,
	nmsBaseUrl: import.meta.env.VITE_NMS_API_URL,
	bmsBaseUrl: import.meta.env.VITE_BMS_API_URL,
	socketUrl: import.meta.env.VITE_WEBSOCKET_URL
};
